import { combineReducers } from "@reduxjs/toolkit";
import addQuestion from "./add-question/dataSlice";
import create from "./create/dataSlice";
import deleteTheme from "./delete/dataSlice";
import getModelById from "./get-by-id/dataSlice";
import list from "./list/dataSlice";
import listModelsForTheme from "./list-models-for-theme/dataSlice";
import reorderQuestionsModel from "./reorder-questions/dataSlice";
import update from "./update/dataSlice";
import updateDashboardOrder from "./update-dashboard-order/dataSlice";

const reducer = combineReducers({
  create,
  delete: deleteTheme,
  getModelById,
  list,
  update,
  addQuestion,
  listModelsForTheme,
  updateDashboardOrder,
  reorderQuestionsModel,
});

export default reducer;
